module.exports = __webpack_public_path__ + "img/metal.f4b0e017.jpeg";